
// // import React, { useState, useEffect, Suspense } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import Modal from 'react-modal';
// // import { getApi, postApi } from '../../../Services/apiService';
// // // import EditUserModal from './editUser';
// // import DeleteModal from '../../SharedComponents/deleteModal';
// // import { permissionName, rolesCrud } from '../../../Json/roleCrud';



// // const Meditation = () => {
// //   const navigate = useNavigate();
// //   const [query, setQuery] = useState('');
// //   const [filterQuery, setFilterQuery] = useState('');
// //   const [users, setUsers] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [deleteModal, setDeleteModal] = useState(false);
// //   const [editUserModal, setEditUserModal] = useState(false);
// //   const [selectedUserId, setSelectedUserId] = useState(null);
// //   const [settingType, setSettingType] = useState('general')
// //   const [roleType, setRoleType] = useState(null)

// //   const [companyDetail, setCompanyDetail] = useState({
// //     name: '',
// //     email: '',
// //     phone: ''
// //   })
// //   const [errors, setErrors] = useState({});
// //   const [settingRoles, setSettingRoles] = useState([])
// //   const [rolesPermissionData, setRolesPermissionData] = useState([])
// //   console.log("rolesPermissionDatarolesPermissionData", rolesPermissionData);

// //   const [permissionValue, setPermissionValue] = useState([])


// //   const handleSelectChange = (moduleName, key, value) => {
// //     console.log(`Module: ${moduleName}, key: ${key}, Selected Value: ${value}`);
// //     setRolesPermissionData((prevData) =>
// //       prevData.map((permission) =>
// //         permission.name === moduleName
// //           ? { ...permission, [key]: Number(value) } // Update only the matched permission
// //           : permission
// //       )
// //     );
// //   };

// //   useEffect(() => {
// //     // fetchUsers();
// //   }, [query, editUserModal, deleteModal]); // Fetch users on component mount

// //   useEffect(() => {
// //     // fetchRoles()
// //     fetchGeneralData()
// //   }, [])

// //   const fetchGeneralData = async () => {
// //     const resp = await getApi('/company-setting')

// //     if (resp?.success === true) {
// //       setCompanyDetail({
// //         name: resp?.data?.companySetting?.name || '',
// //         email: resp?.data?.companySetting?.email || '',
// //         phone: resp?.data?.companySetting?.phone || ''
// //       })
// //     }
// //   }
// //   // Handle search input change
// //   const handleSearchChange = (event) => {
// //     setQuery(event.target.value);
// //     // fetchUsers();  // Trigger the search immediately after keyup
// //   };
// //   const openModal = (selectedUser) => {
// //     setSelectedUserId(selectedUser); // Store the selected user ID
// //     setEditUserModal(true);
// //   };
// //   const openDeleteUserModal = (id) => {
// //     setSelectedUserId(id); // Store the selected user ID
// //     setDeleteModal(true);  // Open the delete modal
// //   };

// //   const handleInputChange = (e) => {
// //     const { name, value } = e.target;
// //     setCompanyDetail((prev) => ({
// //       ...prev,
// //       [name]: value,
// //     }));
// //   };

// //   const validateForm = () => {
// //     let errors = {};
// //     if (!companyDetail.name.trim()) errors.name = "Company name is required";
// //     if (!companyDetail.email.trim()) errors.email = "Email is required";
// //     else if (!/^\S+@\S+\.\S+$/.test(companyDetail.email))
// //       errors.email = "Invalid email format";
// //     if (!companyDetail.phone.trim()) errors.phone = "Phone number is required";
// //     else if (!/^\d{10}$/.test(companyDetail.phone))
// //       errors.phone = "Phone number must be 10 digits";

// //     setErrors(errors);
// //     return Object.keys(errors).length === 0;
// //   };

// //   const handleSave = async (e) => {
// //     e.preventDefault();
// //     if (validateForm()) {
// //       console.log("Saving company details:", companyDetail);
// //       const resp = await postApi('/company-setting', companyDetail)
// //       if (resp?.success === true) {
// //         fetchGeneralData()
// //       }
// //     }
// //   };

// //   const handleRole = (type) => {
// //     setSettingType(type)
// //     if (type === 'role') {
// //       handleRoleGet()
// //     }
// //   }

// //   const handleRoleGet = async () => {
// //     const resp = await getApi('/roles')
// //     if (resp?.success === true) {
// //       setSettingRoles(resp?.data?.roles)
// //     }
// //   }

// //   const handleRolePermission = async (id) => {
// //     setRoleType(id)
// //     const resp = await getApi(`/roles/${id}/permissions`)
// //     if (resp?.success === true) {
// //       setRolesPermissionData(resp?.data?.permissions)
// //       setPermissionValue(resp?.data?.permissions.map(item => item.name))
// //     }
// //   }

// //   const handleSaveData = async () => {
// //     const permissionsData = {};

// //     rolesPermissionData.forEach(permission => {
// //       permissionsData[permission.id] = {  
// //         add: permission.add || 0,
// //         view: permission.view || 0,
// //         update: permission.update || 0,
// //         delete: permission.delete || 0
// //       };
// //     });

// //     const payload = {
// //       permissions: permissionsData 
// //     };

// //     console.log("Payload being sent:", payload);

// //     const resp = await postApi(`/roles/${roleType}/permissions`, payload);
// //     if (resp?.success === true) {
// //       console.log("Permissions saved successfully!");
// //     } else {
// //       console.error("Failed to save permissions:", resp);
// //     }
// //     setRoleType(null)
// //   };

// //   return (
// //     <div className='RightSideDiv'>

// //       <div className='row'>
// //         <div className='col-sm-2'>
// //           <div className='setting-left'>
// //             <div className="search-header"><img src={window.getPublicUrl("/assets/images/header-search.svg")} alt="icon" /><input type="text" placeholder="Search here" />
// //               <ul>
// //                 <li onClick={() => { handleRole('general'); setRoleType(null) }}>
// //                   <a className={settingType === 'general' ? 'active' : ''}>General</a>
// //                 </li>
// //                 <li onClick={() => { handleRole('role'); setRoleType(null) }}>
// //                   <a className={settingType === 'role' ? 'active' : ''}>Role & Permission </a>
// //                 </li>
// //               </ul>
// //             </div>
// //           </div>
// //         </div>
// //         <div className='col-sm-10'>
// //           <div className='setting-right setting-right-table'>
// //             <h3>{settingType === 'general' ? 'General' : 'Role & Permissions'}</h3>
// //             {settingType === 'general' ?
// //               <div className='setting-inner'>
// //                 <div className='row'>
// //                   <div className='col-sm-6'>
// //                     <div className='form-group'>
// //                       <label>Copmpany Name<strong>*</strong></label>
// //                       <input type="text" name='name' className="form-control" placeholder="Enter company Name" value={companyDetail?.name} onChange={handleInputChange} />
// //                     </div>
// //                     {errors.name && <span className="error-text">{errors.name}</span>}
// //                   </div>
// //                   <div className='col-sm-6'>
// //                     <div className='form-group'>
// //                       <label>Default Email<strong>*</strong></label>
// //                       <input type="text" name='email' className="form-control" placeholder="Company@gmail.com" value={companyDetail?.email} onChange={handleInputChange} />
// //                     </div>
// //                     {errors.email && <span className="error-text">{errors.email}</span>}
// //                   </div>
// //                   <div className='col-sm-6'>
// //                     <div className='form-group'>
// //                       <label>Company Phone<strong>*</strong></label>
// //                       <input type="text" name='phone' className="form-control" placeholder="1234567891" value={companyDetail?.phone} onChange={handleInputChange} />
// //                     </div>
// //                     {errors.phone && <span className="error-text">{errors.phone}</span>}
// //                   </div>
// //                   <div className='col-sm-12'>
// //                     <button className='save float-inline-end' onClick={handleSave}>Save</button>
// //                   </div>

// //                 </div>
// //               </div>
// //               :
// //               <div className='setting-inner'>
// //                 {settingRoles && settingRoles?.length > 0 && settingRoles.map((x, index) => {
// //                   return (
// //                     <div className="role-permission-card">
// //                       <div className="left-content" ><h2>{x?.name}</h2><p>{x?.description}</p></div>
// //                       <div className="right-content" onClick={() => setRoleType(x?.id)}>
// //                         {x?.is_editable == 0 ?
// //                           <p>Admin permissions can not be changed</p>
// //                           :
// //                           <span onClick={() => handleRolePermission(x?.id)}><img src={window.getPublicUrl("/assets/images/permision.png")} alt="" />Permissions</span>
// //                         }
// //                       </div>
// //                     </div>
// //                   )
// //                 })}

// //                 {roleType !== null &&
// //                   <div className='permission-table-inner'>
// //                     <table className="custom-table table-striped permission-table roles">
// //                       <thead>
// //                         <tr>
// //                           <th className="module">Moddule</th>
// //                           <th className="add">Add</th>
// //                           <th className="view">View</th>
// //                           <th className="update">Update</th>
// //                           <th className="delete">Delete</th>
// //                           <th className="action"></th>
// //                         </tr>
// //                       </thead>
// //                       <tbody>
// //                         {/* <tr> */}
// //                         {rolesPermissionData.map((module, index) => (
// //                           <tr key={index}>
// //                             <td className="module">{module?.name}</td>
// //                             <td>
// //                               <div className="custom-select">
// //                               <select onChange={(e) => handleSelectChange(module?.name, 'add', e.target.value)} value={module?.add}>
// //                                       <option key={null} value={null}>
// //                                        null
// //                                       </option>
// //                                       <option key={0} value={0}>
// //                                         InActive
// //                                       </option>
// //                                       <option key={1} value={1}>
// //                                         Active
// //                                       </option>
// //                                   </select>
// //                               </div>

// //                             </td>
// //                             <td>
// //                               <div className="custom-select">
// //                               <select onChange={(e) => handleSelectChange(module?.name, 'view', e.target.value)} value={module?.view}>
// //                                       <option key={null} value={null}>
// //                                        null
// //                                       </option>
// //                                       <option key={0} value={0}>
// //                                         InActive
// //                                       </option>
// //                                       <option key={1} value={1}>
// //                                         Active
// //                                       </option>
// //                                   </select>
// //                               </div>

// //                             </td>
// //                             <td>
// //                               <div className="custom-select">
// //                               <select onChange={(e) => handleSelectChange(module?.name, 'update', e.target.value)} value={module?.update}>
// //                                       <option key={null} value={null}>
// //                                        null
// //                                       </option>
// //                                       <option key={0} value={0}>
// //                                         InActive
// //                                       </option>
// //                                       <option key={1} value={1}>
// //                                         Active
// //                                       </option>
// //                                   </select>
// //                               </div>

// //                             </td>
// //                             <td>
// //                               <div className="custom-select">
// //                               <select onChange={(e) => handleSelectChange(module?.name, 'delete', e.target.value)} value={module?.delete}>
// //                                       <option key={null} value={null}>
// //                                        null
// //                                       </option>
// //                                       <option key={0} value={0}>
// //                                         InActive
// //                                       </option>
// //                                       <option key={1} value={1}>
// //                                         Active
// //                                       </option>
// //                                   </select>
// //                               </div>

// //                             </td>
// //                             {/* {Object.keys(rolesCrud.rolesCrud).map((key, roleIndex) => (
// //                               <td key={roleIndex} className={key}>
// //                                 <div className="custom-select">
// //                                   <select onChange={(e) => handleSelectChange(module, key, e.target.value)}>
// //                                     {rolesCrud.rolesCrud[key].options.map((option) => (
// //                                       <option key={option.value} value={option.value}>
// //                                         {option.label}
// //                                       </option>
// //                                     ))}
// //                                   </select>
// //                                 </div>
// //                               </td>
// //                             ))} */}
// //                           </tr>
// //                         ))}
// //                         {/* {permissionValue.map((module, index) => (
// //                           <tr key={index}>
// //                             <td className="module">{module}</td>
// //                             {Object.keys(rolesCrud.rolesCrud).map((key, roleIndex) => (
// //                               <td key={roleIndex} className={key}>
// //                                 <div className="custom-select">
// //                                   <select onChange={(e) => handleSelectChange(module, key, e.target.value)}>
// //                                     {rolesCrud.rolesCrud[key].options.map((option) => (
// //                                       <option key={option.value} value={option.value}>
// //                                         {option.label}
// //                                       </option>
// //                                     ))}
// //                                   </select>
// //                                 </div>
// //                               </td>
// //                             ))}
// //                           </tr>
// //                         ))} */}
// //                         {/* </tr> */}

// //                       </tbody>
// //                     </table>
// //                     <button className='save float-end' onClick={() => handleSaveData()}>Save</button>
// //                   </div>
// //                 }

// //               </div>
// //             }
// //           </div>
// //         </div>
// //       </div>
// //       {loading && <p>Loading...</p>}
// //       {/* {error && <p className="error-message">{error}</p>} */}
// //       <Suspense fallback={<div>Loading...</div>}>
// //         <Modal isOpen={deleteModal} onRequestClose={() => setDeleteModal(false)} contentLabel="Delete Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
// //           overlayClassName={`modal-overlay add-category delete logout `}
// //           portalClassName="add-user delete">
// //           <DeleteModal setDeleteModal={setDeleteModal} userDetails={selectedUserId} title={'this user'} comp={'user'} />
// //         </Modal>
// //       </Suspense>
// //     </div>


// //   );
// // };


// // export default Meditation;

// import React, { useState, useEffect, Suspense } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Modal from 'react-modal';
// import { getApi, postApi } from '../../../Services/apiService';
// import DeleteModal from '../../SharedComponents/deleteModal';

// // Loader Component
// const Loader = () => (
//   <div className="text-center py-3">
//   <div className="spinner-border spinner-border-sm" role="status">
//     <span className="visually-hidden">Loading...</span>
//   </div>
// </div>
// );

// const Meditation = () => {
//   const navigate = useNavigate();
//   const [query, setQuery] = useState('');
//   const [users, setUsers] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [deleteModal, setDeleteModal] = useState(false);
//   const [editUserModal, setEditUserModal] = useState(false);
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const [settingType, setSettingType] = useState('general');
//   const [expandedRole, setExpandedRole] = useState(null);

//   const [companyDetail, setCompanyDetail] = useState({
//     name: '',
//     email: '',
//     phone: ''
//   });
//   const [errors, setErrors] = useState({});
//   const [settingRoles, setSettingRoles] = useState([]);
//   const [rolesPermissionData, setRolesPermissionData] = useState([]);
//   const [permissionValue, setPermissionValue] = useState([]);

//   const handleSelectChange = (moduleName, key, value) => {
//     setRolesPermissionData((prevData) =>
//       prevData.map((permission) =>
//         permission.name === moduleName
//           ? {
//             ...permission,
//             [key]: value === "null" ? null : Number(value)
//           }
//           : permission
//       )
//     );
//   };

//   useEffect(() => {
//     fetchGeneralData();
//   }, []);

//   const fetchGeneralData = async () => {
//     try {
//       setIsLoading(true);
//       setError(null);
//       const resp = await getApi('/company-setting');
//       if (resp?.success === true) {
//         setCompanyDetail({
//           name: resp?.data?.companySetting?.name || '',
//           email: resp?.data?.companySetting?.email || '',
//           phone: resp?.data?.companySetting?.phone || ''
//         });
//       }
//     } catch (error) {
//       setError(error.message || 'Failed to fetch company settings');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setCompanyDetail((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const validateForm = () => {
//     let errors = {};
//     if (!companyDetail.name.trim()) errors.name = "Company name is required";
//     if (!companyDetail.email.trim()) errors.email = "Email is required";
//     else if (!/^\S+@\S+\.\S+$/.test(companyDetail.email))
//       errors.email = "Invalid email format";
//     if (!companyDetail.phone.trim()) errors.phone = "Phone number is required";
//     else if (!/^\d{10}$/.test(companyDetail.phone))
//       errors.phone = "Phone number must be 10 digits";

//     setErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleSave = async (e) => {
//     e.preventDefault();
//     if (validateForm()) {
//       try {
//         setIsLoading(true);
//         setError(null);
//         const resp = await postApi('/company-setting', companyDetail);
//         if (resp?.success === true) {
//           fetchGeneralData();
//         }
//       } catch (error) {
//         setError(error.message || 'Failed to save company settings');
//       } finally {
//         setIsLoading(false);
//       }
//     }
//   };

//   const handleRole = (type) => {
//     setSettingType(type);
//     setExpandedRole(null);
//     if (type === 'role') {
//       handleRoleGet();
//     }
//   };

//   const handleRoleGet = async () => {
//     try {
//       setIsLoading(true);
//       setError(null);
//       const resp = await getApi('/roles');
//       if (resp?.success === true) {
//         setSettingRoles(resp?.data?.roles);
//       }
//     } catch (error) {
//       setError(error.message || 'Failed to fetch roles');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const toggleRoleAccordion = async (roleId) => {
//     if (expandedRole === roleId) {
//       setExpandedRole(null);
//     } else {
//       try {
//         setIsLoading(true);
//         setError(null);
//         setExpandedRole(roleId);
//         const resp = await getApi(`/roles/${roleId}/permissions`);
//         if (resp?.success === true) {
//           setRolesPermissionData(resp?.data?.permissions);
//           setPermissionValue(resp?.data?.permissions.map(item => item.name));
//         }
//       } catch (error) {
//         setError(error.message || 'Failed to fetch permissions');
//       } finally {
//         setIsLoading(false);
//       }
//     }
//   };

//   const handleSaveData = async () => {
//     if (!expandedRole) return;

//     try {
//       setIsLoading(true);
//       setError(null);
//       const permissionsData = {};
//       rolesPermissionData.forEach(permission => {
//         permissionsData[permission.id] = {
//           add: permission.add || 0,
//           view: permission.view || 0,
//           update: permission.update || 0,
//           delete: permission.delete || 0
//         };
//       });

//       const payload = {
//         permissions: permissionsData
//       };

//       const resp = await postApi(`/roles/${expandedRole}/permissions`, payload);
//       if (resp?.success === true) {
//         handleRoleGet();
//       }
//     } catch (error) {
//       setError(error.message || 'Failed to save permissions');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className='RightSideDiv'>
//       {/* {isLoading && <Loader />} */}

//       <div className='row'>
//         <div className='col-sm-2'>
//           <div className='setting-left'>
//             <div className="search-header">
//               <img src={window.getPublicUrl("/assets/images/header-search.svg")} alt="icon" />
//               <input
//                 type="text"
//                 placeholder="Search here"
//                 value={query}
//                 onChange={(e) => setQuery(e.target.value)}
//                 disabled={isLoading}
//               />
//               <ul style={{cursor:'pointer'}}> 
//                 <li onClick={() => { handleRole('general'); }}>
//                   <a className={settingType === 'general' ? 'active' : ''}>General</a>
//                 </li>
//                 <li onClick={() => { handleRole('role'); }}>
//                   <a className={settingType === 'role' ? 'active' : ''}>Role & Permission</a>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//         <div className='col-sm-10'>
//           <div className='setting-right setting-right-table'>
//             <h3>{settingType === 'general' ? 'General' : 'Role & Permissions'}</h3>

//             {error && (
//               <div className="alert alert-danger mb-3">
//                 {error}
//                 <button
//                   type="button"
//                   className="btn-close float-end"
//                   onClick={() => setError(null)}
//                   aria-label="Close"
//                 ></button>
//               </div>
//             )}

//             {settingType === 'general' ? (
//               <div className='setting-inner'>
//                 <div className='row'>
//                   <div className='col-sm-6'>
//                     <div className='form-group'>
//                       <label>Company Name<strong>*</strong></label>
//                       <input
//                         type="text"
//                         name='name'
//                         className={`form-control ${errors.name ? 'is-invalid' : ''}`}
//                         placeholder="Enter company Name"
//                         value={companyDetail?.name}
//                         onChange={handleInputChange}
//                         disabled={isLoading}
//                       />
//                       {errors.name && <div className="invalid-feedback">{errors.name}</div>}
//                     </div>
//                   </div>
//                   <div className='col-sm-6'>
//                     <div className='form-group'>
//                       <label>Default Email<strong>*</strong></label>
//                       <input
//                         type="text"
//                         name='email'
//                         className={`form-control ${errors.email ? 'is-invalid' : ''}`}
//                         placeholder="Company@gmail.com"
//                         value={companyDetail?.email}
//                         onChange={handleInputChange}
//                         disabled={isLoading}
//                       />
//                       {errors.email && <div className="invalid-feedback">{errors.email}</div>}
//                     </div>
//                   </div>
//                   <div className='col-sm-6'>
//                     <div className='form-group'>
//                       <label>Company Phone<strong>*</strong></label>
//                       <input
//                         type="text"
//                         name='phone'
//                         className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
//                         placeholder="1234567891"
//                         value={companyDetail?.phone}
//                         onChange={handleInputChange}
//                         disabled={isLoading}
//                       />
//                       {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
//                     </div>
//                   </div>
//                   <div className='col-sm-12'>
//                     <button
//                       className='save float-inline-end'
//                       onClick={handleSave}
//                       disabled={isLoading}
//                     >
//                       {isLoading ? (
//                         <>
//                           <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                           Saving...
//                         </>
//                       ) : 'Save'}
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               <div className='setting-inner'>
//                 {isLoading && !expandedRole ? (
//                   <div className="text-center py-3">
//                   <div className="spinner-border spinner-border-sm" role="status">
//                     <span className="visually-hidden">Loading...</span>
//                   </div>
//                 </div>
//                 ) : (
//                   settingRoles?.map((role) => (
//                     <div key={role.id} className="role-permission-accordion">
//                       <div
//                         className={`role-permission-card ${expandedRole === role.id ? 'expanded' : ''}`}
//                         onClick={() => role.is_editable !== 0 && !isLoading && toggleRoleAccordion(role.id)}
//                       >
//                         <div className="left-content">
//                           <h2>{role.description}</h2>
//                           <p>{role.users_count} Member</p>
//                         </div>
//                         <div className="right-content">
//                           {role.is_editable == 0 ? (
//                             <p>Admin permissions can not be changed</p>
//                           ) : (
//                             <span className='permission-role'>
//                               <img src={window.getPublicUrl("/assets/images/permision.png")} alt="" />
//                               Permissions
//                               <i className={`fas fa-chevron-${expandedRole === role.id ? 'up' : 'down'}`}></i>
//                             </span>
//                           )}
//                         </div>
//                       </div>

//                       {expandedRole === role.id && (
//                         <div className='permission-table-inner'>
//                           {isLoading ? (
//                             <div className="text-center py-3">
//                               <div className="spinner-border spinner-border-sm" role="status">
//                                 <span className="visually-hidden">Loading...</span>
//                               </div>
//                             </div>
//                           ) : (
//                             <>
//                               <table className="custom-table table-striped permission-table roles">
//                                 <thead>
//                                   <tr>
//                                     <th className="module">Module</th>
//                                     <th className="add">Add</th>
//                                     <th className="view">View</th>
//                                     <th className="update">Update</th>
//                                     <th className="delete">Delete</th>
//                                   </tr>
//                                 </thead>
//                                 <tbody>
//                                   {rolesPermissionData.map((module, index) => (
//                                     <tr key={index}>
//                                       <td className="module">{module?.description}</td>
//                                       <td>
//                                         <div className="custom-select">
//                                           <select
//                                             onChange={(e) => handleSelectChange(module?.name, 'add', e.target.value)}
//                                             value={module?.add === null ? "" : module?.add}
//                                             disabled={isLoading}
//                                           >
//                                             <option value="" disabled>select</option>
//                                             <option value="0">Inactive</option>
//                                             <option value="1">Active</option>
//                                           </select>
//                                         </div>
//                                       </td>
//                                       <td>
//                                         <div className="custom-select">
//                                           <select
//                                             onChange={(e) => handleSelectChange(module?.name, 'view', e.target.value)}
//                                             value={module?.view === null ? "" : module?.view}
//                                             disabled={isLoading}
//                                           >
//                                             <option value="" disabled>select</option>
//                                             <option value="0">Inactive</option>
//                                             <option value="1">Active</option>
//                                           </select>
//                                         </div>
//                                       </td>
//                                       <td>
//                                         <div className="custom-select">
//                                           <select
//                                             onChange={(e) => handleSelectChange(module?.name, 'update', e.target.value)}
//                                             value={module?.update === null ? "" : module?.update}
//                                             disabled={isLoading}
//                                           >
//                                             <option value="" disabled>select</option>
//                                             <option value="0">Inactive</option>
//                                             <option value="1">Active</option>
//                                           </select>
//                                         </div>
//                                       </td>
//                                       <td>
//                                         <div className="custom-select">
//                                           <select
//                                             onChange={(e) => handleSelectChange(module?.name, 'delete', e.target.value)}
//                                             value={module?.delete === null ? "" : module?.delete}
//                                             disabled={isLoading}
//                                           >
//                                             <option value="" disabled>select</option>
//                                             <option value="0">Inactive</option>
//                                             <option value="1">Active</option>
//                                           </select>
//                                         </div>
//                                       </td>
//                                     </tr>
//                                   ))}
//                                 </tbody>
//                               </table>
//                               <button
//                                 className='save float-end'
//                                 onClick={handleSaveData}
//                                 disabled={isLoading}
//                               >
//                                 {isLoading ? (
//                                   <>
//                                     <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                                     Saving...
//                                   </>
//                                 ) : 'Save Permissions'}
//                               </button>
//                             </>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   ))
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <Suspense fallback={<Loader />}>
//         <Modal
//           isOpen={deleteModal}
//           onRequestClose={() => setDeleteModal(false)}
//           contentLabel="Delete Modal"
//           shouldCloseOnOverlayClick={false}
//           ariaHideApp={false}
//           overlayClassName={`modal-overlay add-category delete logout`}
//           portalClassName="add-user delete"
//         >
//           <DeleteModal
//             setDeleteModal={setDeleteModal}
//             userDetails={selectedUserId}
//             title={'this user'}
//             comp={'user'}
//           />
//         </Modal>
//       </Suspense>
//     </div>
//   );
// };

// export default Meditation;



import React, { useState, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import DeleteModal from '../../SharedComponents/deleteModal';
import GeneralSettings from '../GeneralSettings/generalSettings';
import RolePermissions from '../Roles&Permissions/rolesPermission';

const Setting = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [settingType, setSettingType] = useState('general');

  const handleSettingTypeChange = (type) => {
    setSettingType(type);
    setError(null);
  };

  return (
    <div className='RightSideDiv'>
      <div className='row'>
        <div className='col-sm-2'>
          <div className='setting-left'>
            {/* <div className="search-header"> */}
            <div>
              {/* <img src={window.getPublicUrl("/assets/images/header-search.svg")} alt="icon" />
              <input
                type="text"
                placeholder="Search here"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                disabled={isLoading}
              /> */}
              <ul style={{cursor:'pointer'}}> 
                <li onClick={() => handleSettingTypeChange('general')}>
                  <a className={settingType === 'general' ? 'active' : ''}>General</a>
                </li>
                <li onClick={() => handleSettingTypeChange('role')}>
                  <a className={settingType === 'role' ? 'active' : ''}>Role & Permission</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='col-sm-10'>
          <div className='setting-right setting-right-table hidden-over-flow'>
            <h3>{settingType === 'general' ? 'General' : 'Role & Permissions'}</h3>

            {error && (
              <div className="alert alert-danger mb-3">
                {error}
                <button
                  type="button"
                  className="btn-close float-end"
                  onClick={() => setError(null)}
                  aria-label="Close"
                ></button>
              </div>
            )}

            {settingType === 'general' ? (
              <GeneralSettings 
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                setError={setError}
              />
            ) : (
              <RolePermissions 
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                setError={setError}
              />
            )}
          </div>
        </div>
      </div>

      <Suspense fallback={<div>Loading...</div>}>
        <Modal
          isOpen={deleteModal}
          onRequestClose={() => setDeleteModal(false)}
          contentLabel="Delete Modal"
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName={`modal-overlay add-category delete logout`}
          portalClassName="add-user delete"
        >
          <DeleteModal
            setDeleteModal={setDeleteModal}
            userDetails={selectedUserId}
            title={'this user'}
            comp={'user'}
          />
        </Modal>
      </Suspense>
    </div>
  );
};

export default Setting;